/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{6AE7ADFC-741D-43B5-BE48-C87A6F662CBF}",
  "sitecoreApiHost": "https://www.osim.com.my",
  "jssAppName": "osim-web-shop-my",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/osim-web-shop",
  "buildTime": "Wed Apr 17 2024 12:03:46 GMT+0700 (Indochina Time)",
  "gitVersion": "3daf68780417289c5c160dbed72abd6bee35fdf1",
  "graphQLEndpoint": "https://www.osim.com.my/api/osim-web-shop?sc_apikey={6AE7ADFC-741D-43B5-BE48-C87A6F662CBF}"
};